// ============================================================
// useStudent Hook
// ============================================================

import { useEffect } from 'react';
import useStudentStore from '@/store/studentStore';
import { useSchool } from './useSchool';

export function useStudent(studentId) {
  const { schoolId } = useSchool();
  
  const student = useStudentStore((s) => s.currentStudent);
  const loading = useStudentStore((s) => s.loading);
  const error = useStudentStore((s) => s.error);
  const fetchStudentById = useStudentStore((s) => s.fetchStudentById);
  const clearCurrentStudent = useStudentStore((s) => s.clearCurrentStudent);

  useEffect(() => {
    if (schoolId && studentId) {
      fetchStudentById(schoolId, studentId);
    }
    return () => {
      clearCurrentStudent();
    };
  }, [schoolId, studentId, fetchStudentById, clearCurrentStudent]);

  return { student, loading, error };
}
